import {Component, Input} from '@angular/core';
import {AnnotationHandler} from '../../annotation-handler';

@Component({
    selector: 'app-annotation-dashboard-buttons',
    templateUrl: './annotation-dashboard-buttons.component.html',
    styleUrls: ['./annotation-dashboard-buttons.component.scss'],
    standalone: false
})
export class AnnotationDashboardButtonsComponent {

  @Input() curAnn: AnnotationHandler;
}
